import { Spin } from 'antd';
import Markdown from 'markdown-to-jsx';
import React from 'react';
import { AgentResultResponse } from '@tools/ui/types/generated/graphql';
import {
  AgentNameLabel,
  ErrorCard,
  LoadingCard,
  ResultCard,
  ResultHeader,
  ResultItem,
  StyledSmallTag,
} from './RiskAgentRunner.styled';

const STATUS_FAILED = 'failed';
const COLOR_DONE = '#9254de';
const COLOR_FAILED = '#ff4d4f';

const MARKDOWN_OPTIONS = {
  overrides: {
    h1: { props: { style: { fontSize: 20, fontWeight: 700, marginBottom: 12, marginTop: 0, color: '#141414' } } },
    h2: { props: { style: { fontSize: 16, fontWeight: 600, marginBottom: 10, marginTop: 20, color: '#262626', borderBottom: '1px solid #f0f0f0', paddingBottom: 6 } } },
    h3: { props: { style: { fontSize: 14, fontWeight: 600, marginBottom: 8, marginTop: 16, color: '#434343' } } },
    p:  { props: { style: { marginBottom: 12, marginTop: 0 } } },
    ul: { props: { style: { paddingLeft: 20, marginBottom: 12 } } },
    ol: { props: { style: { paddingLeft: 20, marginBottom: 12 } } },
    li: { props: { style: { marginBottom: 5 } } },
    a:  { props: { style: { color: '#9254de' }, target: '_blank', rel: 'noreferrer' } },
    strong: { props: { style: { fontWeight: 600, color: '#141414' } } },
    code: { props: { style: { background: '#f5f5f5', borderRadius: 4, padding: '1px 5px', fontSize: 13, fontFamily: 'monospace' } } },
    pre: { props: { style: { background: '#fafafa', border: '1px solid #f0f0f0', borderRadius: 6, padding: '12px 16px', overflowX: 'auto', fontSize: 13 } } }
  }
};

const statusColor = (status: string) => {
  if (status === STATUS_FAILED) return COLOR_FAILED;
  return COLOR_DONE;
};

type AgentResultCardProps = {
  error: string | null;
  res: AgentResultResponse;
  waitingMessage: string;
};

const AgentResultCard: React.FC<AgentResultCardProps> = ({ error, res, waitingMessage }) => (
  <ResultItem>
    <ResultHeader>
      <AgentNameLabel>{res.agentName}</AgentNameLabel>
      <StyledSmallTag color={statusColor(res.status)}>{res.status}</StyledSmallTag>
    </ResultHeader>
    {res.result ? (
      <ResultCard>
        <Markdown options={MARKDOWN_OPTIONS}>{res.result}</Markdown>
      </ResultCard>
    ) : res.status === STATUS_FAILED ? (
      <ErrorCard>Agent execution failed.</ErrorCard>
    ) : error ? (
      <ErrorCard>{error}</ErrorCard>
    ) : (
      <LoadingCard>
        <Spin size="small" />
        <span>{waitingMessage}</span>
      </LoadingCard>
    )}
  </ResultItem>
);

export { AgentResultCard };
